import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { SMALL_TEXT_PX, DISABLED_FONT_COLOR} from '../../../styles/fonts/MCFontConstants';

export const RadioComponentSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ radioComponentAlignItem }) =>
        radioComponentAlignItem ? radioComponentAlignItem : 'center'};
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '20px'};
    min-height: 28px;
    /* max-height: 15px;
    margin: 25px 0px;
    margin-bottom: 20px; */
    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    }
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    ${media.mediumDevice`
        padding-right:${({ iPadPaddingRight }) =>
            iPadPaddingRight ? iPadPaddingRight : '20px'};
    `}

    @media only screen and  (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
        /* For ipadPro landscape layouts only */
        padding-right: ${({ iPadPaddingRight, paddingRight }) =>
            iPadPaddingRight ? iPadPaddingRight : paddingRight?paddingRight:'20px'};
    }
`;

export const RadioComponentLabels = styled.label`
    display: flex;
    font-family: ${({ fontFamilyStyle }) =>
        fontFamilyStyle ? fontFamilyStyle : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : SMALL_TEXT_PX )};
    color: ${({ color, disabled }) => disabled ? DISABLED_FONT_COLOR : color};
    align-items: ${({ radioLabelAlignItem }) =>
        radioLabelAlignItem ? radioLabelAlignItem : 'center'};
    padding: ${({ padding }) => (padding ? padding : '')};
    white-space: ${({ noWrap }) => (noWrap ? noWrap : 'normal')};
    ${media.smalDevice`
		max-width: none;
    `}
    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
    }
`;
export const RadioSvg = styled.img`
    margin-right: 10px;
    margin-top: ${({ marginTop }) => marginTop};
    &:hover {
        cursor: ${({ disabled }) => (disabled ? 'no-drop' : 'pointer')};
    }
    filter: ${({ disabled }) => (disabled ? 'grayscale(1) brightness(0.7)' : 'none')};
    opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const RadioFormElement = styled.input`
    display: none;
`;
